import PropTypes from 'prop-types'
import React from 'react'

class ImageLoader extends React.PureComponent {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  }

  state = {
    loaded: false,
    isUsable: false,
  }

  componentDidMount() {
    // check for src validity
    const { src } = this.props

    const image = new Image()
    image.addEventListener('error', e => {
      this.setState({
        loaded: true,
        isUsable: false,
      })
    })

    image.addEventListener('load', e => {
      if (!this.state.loaded) {
        this.setState({
          loaded: true,
          isUsable: true,
        })
      }
    })
    image.src = src
  }

  render() {
    const { placeholder, src, style, className } = this.props
    const { isUsable, loaded } = this.state

    if (!loaded || isUsable === false) {
      return (
        <img
          src={placeholder}
          alt="placeholder"
          style={style}
          className={className}
        />
      )
    }

    return <img src={src} style={style} className={className} alt="contact" />
  }
}

export default ImageLoader
